module.exports = __webpack_public_path__ + "static/media/harp.5d449523.wav";